module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/mw-6807c4fdd0370b23d239d22883ecf478.svg";